// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3LgJh","bigColWidth":"Table_bigColWidth__1aKnR","biggerColWidth":"Table_biggerColWidth__3950t","row":"Table_row__3lzbA","col":"Table_col__3JwlU"};